<div class="modal-container">
  <div>
    <div class="title">{{ 'interview.create' | translate }}</div>
    <p class="timezone-text">In your local timezone (Africa/Tunis)</p>

    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>{{ 'interview.title' | translate }}</mat-label>
      <input matInput [(ngModel)]="title" [placeholder]="'interview.titlePlaceholder' | translate">
    </mat-form-field>

    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>{{ 'interview.date' | translate }}</mat-label>
      <input [min]="minDate" matInput [matDatepicker]="picker" [(ngModel)]="selectedDate">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>{{ 'interview.time_start' | translate }}</mat-label>
      <input matInput type="time" [(ngModel)]="startTime">
    </mat-form-field>

    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>{{ 'interview.time_end' | translate }}</mat-label>
      <input matInput type="time" [(ngModel)]="endTime">
    </mat-form-field>

    <mat-error *ngIf="startTime && endTime && !isTimeRangeValid()">
      {{ 'interview.invalid_time_range' | translate }}
    </mat-error>
    
    <div style="display: flex; gap: 1rem; margin-bottom: 1rem; float: right;">
      <app-button (click)="disableGuests()"
                  [class.active]="guestsEnabled"
                  [label]="'interview.no_guests' | translate"
                  [size]="ButtonSize.LARGE"
                  [state]="isFormComplete() ? ButtonState.REGULAR : ButtonState.DISABLED"
                  [type]="ButtonType.SECONDARY"></app-button>
      <app-button (click)="enableGuests()"
                  [class.active]="guestsEnabled"
                  [label]="'interview.add_guests' | translate"
                  [size]="ButtonSize.LARGE"
                  [state]="ButtonState.REGULAR"
                  [type]="ButtonType.PRIMARY"></app-button>

    </div>


    <div style="margin-top: 1.5rem;">



      <ng-container *ngIf="guestsEnabled && guests.length > 0">


        <div class="title" style="margin-bottom: 0.5rem;">
          {{ 'interview.guests' | translate }}
        </div>

        <div *ngFor="let guest of guests; let i = index" class="guest-row">
          <mat-form-field class="guest-field" appearance="fill">
            <mat-label>{{ 'interview.guest_name' | translate }}</mat-label>
            <input matInput [(ngModel)]="guest.guestName" name="guestName{{i}}" required>
            <mat-error *ngIf="guest.guestName === ''">{{ 'interview.required' | translate }}</mat-error>
          </mat-form-field>

          <mat-form-field class="guest-field" appearance="fill">
            <mat-label>{{ 'interview.guest_email' | translate }}</mat-label>
            <input matInput [(ngModel)]="guest.guestEmail" name="guestEmail{{i}}" required email>
            <mat-error *ngIf="!isValidEmail(guest.guestEmail)">{{ 'interview.invalid_email' | translate }}</mat-error>
          </mat-form-field>

          <button (click)="removeGuest(i)" class="icon-button" aria-label="Delete Guest">
            <img class="edit-icon" src="assets/icons/delete.png" alt="Delete">
          </button>
          <button (click)="addGuest()" class="icon-button" aria-label="Add Guest">➕</button>

        </div>
        <div style="margin-top: 2rem;">
          <app-button
            style="width: 10%; float: right;"
            (click)="confirm(true)"
            [label]="'confirm' | translate"
            [size]="ButtonSize.LARGE"
            [state]="canConfirmWithGuests() ? ButtonState.REGULAR : ButtonState.DISABLED"
            [type]="ButtonType.PRIMARY">
          </app-button>
        </div>

      </ng-container>


    </div>



  </div>
</div>
